import { useTranslation } from 'react-i18next'
import {
  LanguageIcon,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems
} from '@itsrever/design-system'
import { clsx } from 'clsx'

export const languageLabels = {
  en: 'English',
  es: 'Español',
  it: 'Italiano',
  fr: 'Français',
  pt: 'Português',
  pl: 'Polski'
}

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation()
  const language = i18n.language

  const isCurrentLanguage = (lang: string) => language === lang

  const handleChange = (lang: string) => {
    localStorage.setItem('userPreferredLang', lang)
    i18n.changeLanguage(lang)
  }

  return (
    <Menu>
      <MenuButton>
        <div
          className={clsx(
            'ml-auto flex items-center justify-center',
            'size-9 rounded-lg bg-[#2C3242] text-white'
          )}
        >
          <LanguageIcon
            className="opacity-90"
            style={{ transform: 'scale(1.3)' }}
          />
        </div>
      </MenuButton>
      <MenuItems
        anchor={{ to: 'top end', gap: '6px' }}
        className={clsx(
          'rounded-lg border border-solid border-[#353C4E] bg-[#1D222E] p-2'
        )}
        styled={false}
      >
        {Object.entries(languageLabels).map(([lang, label]) => (
          <MenuItem key={lang}>
            <p
              className={clsx(
                'cursor-pointer rounded-md p-2 text-sm text-white',
                isCurrentLanguage(lang)
                  ? 'bg-[#2C3242]'
                  : 'data-[focus]:bg-[#2C3242]/70'
              )}
              onClick={() => handleChange(lang)}
            >
              {label}
            </p>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  )
}

export default LanguageSwitcher
